export default "__VITE_ASSET__Ba5nGXU3__"